import {
  StepperSelectionEvent,
  STEPPER_GLOBAL_OPTIONS,
} from '@angular/cdk/stepper';
import { Component } from '@angular/core';
import { SimulationWizardDataService } from '../simulation-wizard-data.service';
import { MatStepper } from '@angular/material/stepper';
import { FormControlStatus } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
@Component({
  selector: 'app-simulation-wizard-container',
  templateUrl: './simulation-wizard-container.component.html',
  styleUrls: ['./simulation-wizard-container.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
})
export class SimulationWizardContainerComponent {
  constructor(
    public simWizardDataService: SimulationWizardDataService,
    private notify: NotificationService
  ) {}

  public selectionChange(e: StepperSelectionEvent): void {
    if (e.selectedIndex === 3)
      this.simWizardDataService.newSummaryInit.next(true);
    else this.simWizardDataService.newSummaryInit.next(false);
    this.simWizardDataService.zimWizard.selectStepperIndex(e.selectedIndex);
  }

  public nextClick(stepper: MatStepper): void {
    if (stepper.selectedIndex === 3) {
      this.simWizardDataService.startSimulation();
    } else {
      const status: FormControlStatus = stepper.selected.stepControl
        .status as FormControlStatus;
      if (status === 'INVALID') {
        this.notify.showError(
          `Please selected one or more ${
            this.simWizardDataService.zimWizard.navItemsConfig[
              stepper.selectedIndex
            ].header
          }`,
          3000
        );
        return;
      }
      stepper.next();
    }
  }

  public backClick(stepper: MatStepper): void {
    if (stepper.selectedIndex === 0) this.simWizardDataService.closeWizard();
    stepper.previous();
  }

  public isNextButtonDisabled(currentIndex): boolean {
    switch (currentIndex) {
      case 0:
        return this.simWizardDataService.zimWizard.patterns?.length < 1;
      case 1:
        return this.simWizardDataService.zimWizard.hardwares?.length < 1;
      case 2:
        return (
          (this.simWizardDataService.zimWizard.softwares?.length ?? 0) < 1 &&
          (this.simWizardDataService.zimWizard.softwarePresets?.length ?? 0) < 1
        );
      case 3:
        return (
          (this.simWizardDataService.zimWizard.patterns?.length ?? 0) < 1 ||
          this.simWizardDataService.zimWizard.hardwares?.length < 1 ||
          ((this.simWizardDataService.zimWizard.softwares?.length ?? 0) < 1 &&
            (this.simWizardDataService.zimWizard.softwarePresets?.length ?? 0) <
              1)
        );
      default:
        return false;
    }
  }
}
